import { Injectable } from '@angular/core';
import { Constants } from './constants';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

    public setRole(userRole: string) {
      sessionStorage.setItem('role', userRole);
  }

  public removeRole() {
    sessionStorage.removeItem('role');
  }

  public getRole(): string {
    return sessionStorage.getItem('role');
  }

  public setMcid(mcid: string) {
    sessionStorage.setItem('mcid', mcid);
  }

  public getMcid(): string {
    return sessionStorage.getItem('mcid');
  }

  public setInstitutionId(id: string) {
    sessionStorage.setItem('institutionId', id);
  }

  public getInstitutionId(): string {
    return sessionStorage.getItem('institutionId');
  }

  public setInstitutionName(name: string) {
    sessionStorage.setItem('InstitutionName', name);
  }

  public getInstitutionName(): string {
    return sessionStorage.getItem('InstitutionName');
  }

  public setLoggedInCookie() {
    sessionStorage.setItem('LoggedInCookie', Constants.Cookies.LoggedInCookie);
  }

  public getAcgme(): string {
    return sessionStorage.getItem('acgme');
  }

  public setAcgme(acgme: string) {
    if (acgme) {
      sessionStorage.setItem('acgme', acgme);
    }
  }

  public setInstitutionCountryCode(institutionCountryCode: string) {
    if (institutionCountryCode) {
      sessionStorage.setItem('InstitutionCountryCode', institutionCountryCode);
    }
  }

  public getInstitutionCountryCode(): string {
    return sessionStorage.getItem('InstitutionCountryCode');
  }

  public checkLoggedInCookie(): boolean {
    return sessionStorage.getItem('LoggedInCookie') === Constants.Cookies.LoggedInCookie;
  }
}
